import { useCallback } from 'react'
import { UIFLAGS } from '../constants/constants'
import { roleService } from '../services'

interface UsePermissionsProps { 
  uiFlag?: number
}

const usePermissions = ({ uiFlag }: UsePermissionsProps) => {
  const hasPermission = useCallback(
    (flag: number) =>
      !!uiFlag &&
      roleService.hasUiFlag({
        uiFlag,
        flagsToCheck: flag,
      }),
    [uiFlag]
  )

  return {
    isDeletable: hasPermission(UIFLAGS.CAN_DELETE),
    isUpdatable: hasPermission(UIFLAGS.CAN_UPDATE),
    isCreatable: hasPermission(UIFLAGS.CAN_CREATE),
  }
}

export default usePermissions
